import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from '../message/message.service';

@Component({
	selector: 'app-resetpwd',
	templateUrl: './resetpwd.component.html',
	styleUrls: ['../auth-layout/auth-layout.component.css'],
})
export class ResetpwdComponent implements OnInit, OnDestroy {
	changePassWordform;
	public showPassword: boolean;
	public showPasswordOnPress: boolean;
	public showPassword2: boolean;
	public showPasswordOnPress2: boolean;
	code: string = '';

	constructor(
		private auth: AuthenticationService,
		private message: MessageService,
		private form: FormBuilder,
		private route: ActivatedRoute
	) {
		this.changePassWordform = this.form.group({
			password: '',
			passwordRepeat: '',
		});
	}

	ngOnInit() {
		document.body.classList.add('login-page');
		this.route.queryParams.subscribe((params) => {
			this.code = params['code'];
		});
	}

	ngOnDestroy() {
		document.body.classList.remove('login-page');
	}

	reset() {
		var formData: any = new FormData();
		formData.append('password', this.changePassWordform.get('password').value);
		formData.append(
			'passwordRepeat',
			this.changePassWordform.get('passwordRepeat').value
		);
		formData.append('code', this.code);
		console.log(formData.values());
		this.auth.resetPassword(formData).subscribe(
			(data) => {
				this.message.sendMessage(data);
			},
			(error) => {
				console.log(error);
			}
		);
	}
}
